<template>
    <div>
        <div class="loader" v-if="this.isLoading"></div>
        <div class="loadertext" v-if="this.isLoading"> {{ $t('loadingTxt') }}...</div>
        <div class="main-wrapper" :class="{ 'blur-content': this.isLoading }">

            <!--begin::navbar-->
            <navbar-component></navbar-component>
            <!--end::navbar-->

            <div class="page-wrapper">

                <!--begin::content-->
                <div class="page-content">
                    <div class="row">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">

                                    <h4 style="margin-right: 5px" class="float-start"> {{ $t("dokumen_pabean") }} </h4>

                                    <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="createNewDocument()">
                                        <i class="link-icon mdi mdi-plus"></i>
                                        {{ $t("createNew") }}
                                    </button>
                                    <button v-if="permision_role.method_create" class="btn btn-warning float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="uploadDocument()">
                                        <i class="link-icon mdi mdi-upload"></i>
                                        {{ $t("UploadTxt") }}
                                    </button>


                                </div>

                                <div class="card-body">
                                    <vue-good-table title="exim-ceisa-document-list" ref="exim-ceisa-document-list"
                                        mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords" :line-numbers="true" :isLoading.sync="isLoading"
                                        :pagination-options="{

            enabled: true,
            perPageDropdown: [10, 50, 100, 1000, 10000],
            dropdownAllowAll: false,
        }" :rows="rows" :columns="columns">



                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'actions'">

                                                <a href="#" class="me-1"
                                                    v-if="permision_role.method_update && props.row.status == 'DRAFT'"
                                                    title="Edit" @click.prevent="editData(props.index, props.row)">
                                                    <i class="mdi mdi-square-edit-outline"
                                                        style="font-size:16px;color:#66d1d1;"></i>
                                                </a>

                                                <a href="#" title="History" class="text-warning me-1"
                                                    @click.prevent="historyData(props.index, props.row)">
                                                    <i class="mdi mdi-history" style="font-size:16px;"></i>
                                                </a>

                                                <a href="#" class="text-primary me-1"
                                                    v-if="permision_role.method_update && props.row.status == 'DRAFT'"
                                                    title="Rename" @click.prevent="updateAju(props.index, props.row)">
                                                    <i class="mdi mdi-rename-box" style="font-size:16px;"></i>
                                                </a>

                                                <a href="#"
                                                    v-if="permision_role.method_delete && props.row.status == 'DRAFT'"
                                                    title="Delete" class="text-danger me-1"
                                                    @click.prevent="deleteData(props.index, props.row)">
                                                    <i class="mdi mdi-delete" style="font-size:16px"></i>
                                                </a>
                                                <a href="#"
                                                    v-if="permision_role.method_update && props.row.status !== 'DRAFT'"
                                                    title="Update Status" class="text-primary me-1"
                                                    @click.prevent="updateStatus(props.index, props.row)">
                                                    <i class="mdi mdi-backup-restore" style="font-size:16px"></i>
                                                </a>
                                                <a href="#"
                                                    v-if="permision_role.method_create"
                                                    title="Duplicate Document" class="text-primary me-1"
                                                    @click.prevent="duplicateDocument(props.index, props.row)">
                                                    <i class="mdi mdi-content-copy" style="font-size:16px"></i>
                                                </a>
                                                <a href="#"
                                                    v-if="permision_role.method_create"
                                                    title="Download Document" class="text-primary me-1"
                                                    @click.prevent="downloadDocument(props.index, props.row)">
                                                    <i class="mdi mdi-download" style="font-size:16px"></i>
                                                </a>
                                            </span>

                                            <span v-else-if="props.column.field == 'kodeDokumen'">
                                                {{ props.row.namaDokumen }}
                                            </span>
                                            <span v-else-if="props.column.field == 'namaImportir'">
                                                {{ getNamaImportir(props.row) }}
                                            </span>
                                            <span v-else-if="props.column.field == 'nomorAju'">
                                                {{ props.row.nomorAju }} <a href="#" title="Entitas"
                                                    class="text-twitter"
                                                    @click.prevent="entityData(props.index, props.row)">
                                                    <i class="mdi mdi-information-outline" style="font-size:16px;"></i>
                                                </a>
                                            </span>

                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->










                <!--begin::modal-->
                <modal name="createNewDocument" :draggable="false" :scrollable="true" :height="'auto'">
                    <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true"
                        role="dialog">
                        <div class="modal-dialog  modal-xl">
                            <div class="modal-content">

                                <div class="modal-header">
                                    <h5 class="modal-title" id="exampleModalLabel"> {{ $t("create_document") }} </h5>
                                    <button type="button" class="btn btn-default" @click.prevent="removeModals()"
                                        aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>

                                <form class="forms-sample" @submit.prevent="submitcreateNewDocument()" method="POST">
                                    <div class="modal-body">

                                        <div class="mb-3">

                                            <label for="files" class="form-label">{{ this.$t("kodeDokumen") }}:</label>


                                            <v-select :options="fetchkodeDokumen" v-model="kodeDokumen" label="name"
                                                return-object required>
                                                <template slot="option" slot-scope="option">
                                                    {{ option.name }}
                                                </template>
                                            </v-select>

                                            <div v-if="errors.kodeDokumen">
                                                <div v-for="error in errors.kodeDokumen" :key="error"
                                                    class="alert alert-primary" role="alert">
                                                    <i data-feather="alert-circle"></i>
                                                    {{ error }}
                                                </div>
                                            </div>

                                        </div>


                                    </div>


                                    <div class="modal-footer justify-content-between">
                                        <button type="button" class="btn btn-secondary"
                                            @click.prevent="removeModals()">{{ this.$t("close_txt") }}</button>
                                        <button type="submit" class="btn btn-primary" v-if="!errorsDataSoUpload">{{
            this.$t("save_change_txt") }}</button>
                                    </div>
                                </form>


                            </div>
                        </div>
                    </div>
                </modal>
                <!--end::modal-->

                <modalListEntitas :idDocument="selectedId" @closeModal="removeSelectedId"></modalListEntitas>
                <modalHistory :idDocument="selectedId" @closeModal="removeSelectedId"></modalHistory>
                <modalUpdateAju :idDocument="selectedId" :noAju="selectedNoAju" @closeModal="removeSelectedId"></modalUpdateAju>
                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";
import modalListEntitas from "@/components/exim/ceisa/barang_impor/modal/modalListEntitas.vue";
import modalHistory from "@/components/exim/ceisa/barang_impor/modal/modalHistory.vue";
import modalUpdateAju from "@/components/exim/ceisa/barang_impor/modal/modalUpdateAju.vue";

export default {
    name: "CeisaBarangImporIndex",
    components: {
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
        modalListEntitas,
        modalHistory,
        modalUpdateAju,
    },
    data() {
        return {

            selectedId: null,
            selectedNoAju:"",
            cancelBtn: false,

            digit: {
                decimal: ',',
                thousands: '.',
                prefix: ' ',
                suffix: '',
                precision: 5,
                masked: false
            },

            locale: {
                format: "yyyy-mm-dd",

            },
            highlighted: {

                dates: [ // Highlight an array of dates
                    new Date(),
                ],

            },
            dateTimes: '',
            fromDates: {
                startDate: null,
                endDate: null
            },
            firstDates: {
                startDate: null,
                endDate: null
            },
            fetchPpjk: [],
            ppjk: { ppjk_id: "", nama: "", alamat: "", no_npwp: "", np_ppjk: "" },
            filterOrderType: [],
            kodeDokumen: { name: "", code: "" },
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            errors: [],
            idOrderHeaders: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            BAS_SKU_IDs: [],
            detailDivisi: [],
            totalRecords: 0,
            activeFlag: false,
            shelfLifeFlag: false,
            kitFlag: false,
            freePickGift: false,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },

            fetchkodeDokumen: [],

            columns: [

                {
                    label: this.$t('document_id'),
                    field: "document_id",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('kodeDokumen'),
                    field: "kodeDokumen",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: this.$t('nomorAju'),
                    field: "nomorAju",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },



                {
                    label: this.$t('tanggalAju'),
                    field: "tanggalAju",
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },

                {
                    label: this.$t('namaImportir'),
                    field: "namaImportir",
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('namaRespon'),
                    field: "namaRespon",
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [],
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },



                {
                    label: this.$t('tanggalRespon'),
                    field: "tanggalRespon",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('jalur'),
                    field: "jalur",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('kodeKantor'),
                    field: "kodeKantor",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: this.$t('status'),
                    field: "status",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },


                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                        customFilter: false,
                    }
                },

            ],
            rows: [],
            rowsSelection: [],
            errorsDataSoUpload: false,
        };
    },
    watch: {},
    methods: {
        downloadDocument(index,row){
            const baseURI =
                this.$settings.endPointCeisa + "v1/document/download-document/" + row.document_id;
            var file_name = "document_detail-"+row.nomorAju+".xlsx";

            this.isLoading = true;
            return this.$http.get(
                baseURI,
                {
                    responseType: "blob",
                }
            ).then((response) => {
            
                this.isLoading = false;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement("a");

                fileLink.href = fileURL;
                fileLink.setAttribute("download", file_name);
                document.body.appendChild(fileLink);
                fileLink.click();
                this.fade(false);
            }).catch((error) => {

                this.isLoading = false;

                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                } else {


                    if (error.code == "ECONNABORTED") {
                        
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                            this.errors = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                            this.logout();
                            } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                            } else {
                            this.$router.push('/page-not-found');
                            }
                        }

                    }

                }

            });
        },
        duplicateDocument(index,row){
            this.$swal({
                title: this.$t("areYouSure"),
                text: "Duplicate Dokumen Ini ",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI =
                        this.$settings.endPointCeisa + "v1/document/copy-document/" + row.document_id;
                    this.$http
                        .post(baseURI, { timeout: 10000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success("Success");
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },
        getNamaImportir(row){
            var importir = "-";
            if(row.entitas.length > 0){
                row.entitas.forEach(function(data){
                    if(data.namaKodeEntitas == "IMPORTIR"){
                        importir = data.namaEntitas;
                    }
                });
            }
            return importir;
        },
        updateStatus(index, row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourData"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    var send = {
                        "status": "DRAFT"
                    };
                    const baseURI =
                        this.$settings.endPointCeisa + "v1/document/update-status/" + row.document_id;
                    this.$http
                        .post(baseURI, send, { timeout: 10000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success("Berhasil");
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },
        updateAju(index, row) {
            this.selectedId = row.document_id;
            this.selectedNoAju = row.nomorAju;
            this.$modal.show('modalUpdateAju');
        },
        historyData(index, row) {
            this.selectedId = row.document_id;
            this.$modal.show('historyTransaksi');
        },
        removeSelectedId(ev = null) {
            this.selectedId = null;
            this.$modal.hide('listEntitasDetail');
            this.$modal.hide('historyTransaksi');
            this.$modal.hide('modalUpdateAju');

            if (ev == "updateAju") {
                this.loadItems();
                this.success("Success");
            }
        },
        entityData(index, row) {
            this.selectedId = row.document_id;
            this.$modal.show('listEntitasDetail');
        },
        createNewDocument() {
            this.$modal.show('createNewDocument')
        },


        removeModals() {
            this.$modal.hide('createNewDocument')
            this.kodeDokumen = { name: "", code: "" }
            this.loadItems();

        },


        submitcreateNewDocument() {
            this.isLoading = true;

            let formData = new FormData();
            formData.append("kodeDokumen", this.kodeDokumen.code);
            formData.append("namaDokumen", this.kodeDokumen.name);

            const baseURI = this.$settings.endPointCeisa + "v1/document/store-step-1";
            this.$http.post(baseURI, formData).then((response) => {
                this.isLoading = false;

                var params = this.$onRandom(response.data.datas.document_id);
                window.location.href = "/exim/ceisa/dokumen-pabean/create/" + params;


            }).catch((error) => {
                this.loading();


                if (error.code == "ECONNABORTED") {
                    this.error(this.$t("check_internet_connection_txt"));

                } else {

                    if (error.response) {
                        if (error.response.status === 422) {
                            this.errorsDataSoUpload = error.response.data.errors;
                            this.resultError(error.response.data.errors);
                        } else if (error.response.status === 401) {
                            this.logout();
                        } else if (error.response.status === 403) {
                            this.$router.push("/authorized-error");
                        } else if (error.response.status === 500) {
                            this.$router.push('/server-error');
                        } else {
                            this.$router.push('/page-not-found');
                        }
                    }

                }
            });

        },



        editData(index, row) {
            var params = this.$onRandom(row.document_id);
            window.location.href = "/exim/ceisa/dokumen-pabean/create/" + params;
        },
        uploadDocument() {
            window.location.href = "/exim/ceisa/dokumen-pabean/upload";
        },

        detailData(index, row) {
            var params = this.$onRandom(row.document_id);
            window.location.href = "/exim/ceisa/dokumen-pabean/detail/" + params;
        },

        deleteData(index, row) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    this.isLoading = true;
                    const baseURI =
                        this.$settings.endPointCeisa + "v1/document/delete/" + row.document_id;
                    this.$http
                        .delete(baseURI, { timeout: 10000 })
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        }).catch((error) => {
                            this.loading();

                            if (error.code == "ECONNABORTED") {
                                this.error(this.$t("check_internet_connection_txt"));

                            } else {


                                if (error.code == "ECONNABORTED") {
                                    this.error(this.$t("check_internet_connection_txt"));

                                } else {

                                    if (error.response) {
                                        if (error.response.status === 422) {
                                            this.errors = error.response.data.errors;
                                            this.resultError(error.response.data.errors);
                                        } else if (error.response.status === 401) {
                                            this.logout();
                                        } else if (error.response.status === 403) {
                                            this.$router.push("/authorized-error");
                                        } else if (error.response.status === 500) {
                                            this.$router.push('/server-error');
                                        } else {
                                            this.$router.push('/page-not-found');
                                        }
                                    }

                                }

                            }
                        });
                } else {
                    this.isLoading = false;
                }
            });
        },



        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPointCeisa + "v1/document/index";
            this.isLoading = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&kodeDokumen=${this.serverParams.columnFilters.kodeDokumen}&nomorAju=${this.serverParams.columnFilters.nomorAju}&tanggalAju=${this.serverParams.columnFilters.tanggalAju}&namaRespon=${this.serverParams.columnFilters.namaRespon}&tanggalRespon=${this.serverParams.columnFilters.tanggalRespon}&kodeKantor=${this.serverParams.columnFilters.kodeKantor}&status=${this.serverParams.columnFilters.status}&document_id=${this.serverParams.columnFilters.document_id}`,
                    { timeout: 120000 })
                .then((response) => {

                    this.isLoading = false;
                    this.rows = response.data.datas.data;


                    this.totalRecords = response.data.datas.total;
                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },


        loadFilterPPjk() {
            const baseURI = this.$settings.endPointCeisa + "v1/ppjk/index?limit=1000";
            this.isLoading = true;

            return this.$http
                .get(
                    baseURI,
                    { timeout: 10000 })
                .then((response) => {

                    this.fetchPpjk = response.data.datas.data;

                }).catch((error) => {
                    // this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },

        loadFilterType() {
            const baseURI = this.$settings.endPointCeisa + "v1/system-code/index?type=kodeDokumen&limit=1000";
            this.isLoading = true;

            return this.$http
                .get(
                    baseURI,
                    { timeout: 10000 })
                .then((response) => {

                    this.fetchkodeDokumen = response.data.datas.data;

                    for (let index = 0; index < response.data.datas.data.length; index++) {

                        const value = response.data.datas.data[index]['code'];
                        const text = response.data.datas.data[index]['name'];
                        const dataNya = { value: value, text: text }
                        this.columns[1].filterOptions.filterDropdownItems.push(dataNya);

                    }

                }).catch((error) => {
                    // this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },

        updateParams(newProps) {

            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;

            let rolePermision = [];

            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == 'CeisaBarangImporController') {
                    rolePermision = permision;
                }
            });

            if (!rolePermision.method_read) {
                this.$router.push("/authorized-error");
            }
            this.permision_role = rolePermision;

            this.loadFilterType();
            this.loading();

        },


        logout() {

            const baseURI = this.$settings.endPoint + "user/logout";
            this.$http.get(baseURI, { timeout: 10000 }).then((response) => {

                console.log(response);

            });

            this.$logoutUser();
            window.location.href = '/';
        },
        cek_message(status,msg){
            if(status=='200'){
                this.success(msg);
            }
        },


    },
    events: {},
    created: function () { },

    mounted() {
        this.fetchIt();
        this.cek_message(this.$route.query.status,this.$route.query.msg);

    },
};
</script>
<style scoped>
.blur-content {
    filter: blur(5px);
}
</style>